import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=3a6024f1&scoped=true&"
import script from "./SearchBar.vue?vue&type=script&lang=ts&"
export * from "./SearchBar.vue?vue&type=script&lang=ts&"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=3a6024f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6024f1",
  null
  
)

export default component.exports